import { Button, EditableText, Icon } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as React from 'react'

import { dispatch } from '../../store'
import itemStyles from './lecture-item.scss'
import styles from './lecture-missions.scss'

const cx = classnames.bind({ ...styles, ...itemStyles })

interface IProps {
  isEdit: boolean
  missions: string[]
  lectureId: string
}

// interface IState { }

class LectureMissions extends React.Component<IProps> {
  // public state: IState = {}
  public onMissionListTitleChange = (
    title: string,
    id: number,
    missions: string[]
  ) => {
    const { lectureId } = this.props
    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        missions: [...missions.slice(0, id), title, ...missions.slice(id + 1)]
      }
    })
  }

  public deleteMission = (id: number, missions: string[]) => {
    const { lectureId } = this.props
    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        missions: [...missions.slice(0, id), ...missions.slice(id + 1)]
      }
    })
  }

  public addMission = (missions: string[]) => {
    const { lectureId } = this.props
    const mission = 'new mission!'
    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        missions: [...missions, mission]
      }
    })
  }

  public render() {
    // should remind the order
    const { isEdit, missions } = this.props
    const tipsLen = missions.length
    const offest = tipsLen % 2 === 0 ? 0 : 1
    const TipsPart1 = missions.slice(0, tipsLen / 2 + offest)
    const TipsPart2 = missions.slice(tipsLen / 2 + offest, tipsLen)

    return (
      <div className={cx('section')}>
        <div className={cx('section_header', { spaceBetween: true })}>
          你會獲得與討論的觀點
          <div>
            {isEdit ? (
              <Button
                icon="plus"
                text="項目"
                active={true}
                className={cx('section_header_addButton')}
                onClick={this.addMission.bind(this, missions)}
              />
            ) : null}
          </div>
        </div>
        <div className={cx('section_content')}>
          {isEdit ? (
            missions.map((content, id) => (
              <li
                key={`${content}-${id}`}
                className={cx('section_content_list')}
              >
                <div className={cx('section_content_list_editWrapper')}>
                  <EditableText
                    defaultValue={content}
                    placeholder="例如：結構性的單元內容"
                    // tslint:disable-next-line jsx-no-lambda
                    onConfirm={(title: string) =>
                      this.onMissionListTitleChange(title, id, missions)
                    }
                  />
                  <Button
                    icon="trash"
                    text=""
                    active={false}
                    className={cx('section_content_list_deleteButton')}
                    onClick={this.deleteMission.bind(this, id, missions)}
                  />
                </div>
              </li>
            ))
          ) : (
            <div className={cx('tips_wrapper')}>
              <ul>
                {TipsPart1.map((tip, id) => (
                  <li key={id} className={cx('tip')}>
                    <Icon icon="tick" />
                    {tip}
                  </li>
                ))}
              </ul>
              <ul>
                {TipsPart2.map((tip, id) => (
                  <li key={id} className={cx('tip')}>
                    <Icon icon="tick" />
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default LectureMissions



// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-missions.tsx